/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Mp3Inputs */

const en_val_mp3 = /** @type {(inputs: Val_Mp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP3`)
};

const es_val_mp3 = /** @type {(inputs: Val_Mp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP3`)
};

const fr_val_mp3 = /** @type {(inputs: Val_Mp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP3`)
};

const de_val_mp3 = /** @type {(inputs: Val_Mp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP3`)
};

const ja_val_mp3 = /** @type {(inputs: Val_Mp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP3`)
};

const zh_val_mp3 = /** @type {(inputs: Val_Mp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP3`)
};

const ar_val_mp3 = /** @type {(inputs: Val_Mp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP3`)
};

const id_val_mp3 = /** @type {(inputs: Val_Mp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP3`)
};

const it_val_mp3 = /** @type {(inputs: Val_Mp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP3`)
};

const ru_val_mp3 = /** @type {(inputs: Val_Mp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP3`)
};

const pt_val_mp3 = /** @type {(inputs: Val_Mp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP3`)
};

const ko_val_mp3 = /** @type {(inputs: Val_Mp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MP3`)
};

/**
* | output |
* | --- |
* | "MP3" |
*
* @param {Val_Mp3Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_mp3 = /** @type {((inputs?: Val_Mp3Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Mp3Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_mp3(inputs)
	if (locale === "es") return es_val_mp3(inputs)
	if (locale === "fr") return fr_val_mp3(inputs)
	if (locale === "de") return de_val_mp3(inputs)
	if (locale === "ja") return ja_val_mp3(inputs)
	if (locale === "zh") return zh_val_mp3(inputs)
	if (locale === "ar") return ar_val_mp3(inputs)
	if (locale === "id") return id_val_mp3(inputs)
	if (locale === "it") return it_val_mp3(inputs)
	if (locale === "ru") return ru_val_mp3(inputs)
	if (locale === "pt") return pt_val_mp3(inputs)
	return ko_val_mp3(inputs)
});